import SectionJobsListRootPrompts from "../../sections/jobs/section-jobs-listrootprompts";
import SectionJobsListRootImages from "../../sections/jobs/section-jobs-listrootimages";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";


function HomePage() {

    const { t, i18n } = useTranslation()

    //alert(i18n.languages)
    
    useEffect(() => {
        // i18n.changeLanguage("pt-br");
    }, [])

    return (
        <>

            <div className="twm-home3-banner-section twm-bnr-hpage-13">
                <div className="container">
                    <div className="row">
                        <div className="masonry-item col-md-12">


                            <div className="section-head center">
                                <h2 className="wt-title">{t("index.desc1")}</h2>
                                <h4 className="wt-title">{t("index.desc2")}</h4>
                            </div>
                            <div style={{ height: '20px' }}></div>



                            <div style={{ alignContent: "center", textAlign: "center" }}>
                                <ul className="nav nav-tabs" id="myTab3" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link active" id="Monthly" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab">{t("index.lastpublicimages")}</button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link" id="annual" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile">{t("index.lastpublicprompts")}</button>
                                    </li>
                                </ul>
                                <div className="tab-content" id="myTab3Content">
                                    <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="Monthly">
                                        {/*imagelist*/}
                                        <SectionJobsListRootImages />

                                    </div>

                                    <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="annual">
                                        {/* prompts list */}
                                        <SectionJobsListRootPrompts />
                                    </div>
                                </div>
                            </div>
                        </div >
                    </div >
                </div >
            </div >

        </>
    )
}

export default HomePage;